import React, { PropsWithChildren } from 'react'
import { Question, QuestionFrameContext, NumericTextField } from 'components/questions'
import { TextField, Typography } from '@mui/material'
import { useGlobalState } from 'state'


type TextFieldQuestionProps = {
  num: number
  content: string
  rows?: number
  unitLabel?: string
  width?: number
  inputType?: 'text' | 'number' | 'email' | 'tel'
}

export const TextFieldQuestion = ({ num, content, rows = 1, unitLabel = '', width, inputType = 'text', children }: PropsWithChildren<TextFieldQuestionProps>) => {
  const state = useGlobalState()
  const q = React.useContext(QuestionFrameContext)

  const answerValue: string = React.useMemo(() => {
    const answer = state.app.getAnswer(q, num)
    return answer !== null ? answer.value : ''
  }, [state.app.answers])

  const update = (val: string) => {
    if (inputType === 'number') {
      val = val.replace(/[^0-9.-]/g, '')
    } else if (inputType === 'email') {
      val = val.replace(/[^a-zA-Z0-9@._-]/g, '')
    } else if (inputType === 'tel') {
      val = val.replace(/[^0-9-]/g, '')
    }
    state.app.updateAnswer(q, num, val, val !== '')
  }

  return (
    <Question num={num} content={content}>
      {
        inputType === 'number' && <NumericTextField
          value={answerValue}
          onChange={e => update(e.target.value)}
          InputProps={{
            endAdornment: <Typography variant='body1'>{unitLabel}</Typography>
          }}
          sx={{ width: width ? width : 'auto'}}
        />
      }
      {
        inputType !== 'number' && <TextField
          multiline={rows > 1}
          rows={rows}
          value={answerValue}
          onChange={e => update(e.target.value)}
          InputProps={{
            endAdornment: <Typography variant='body1'>{unitLabel}</Typography>
          }}
          sx={{ width: width ? width : 'auto'}}
        />
      }
      {children}
    </Question>
  )
}
